import React, { useEffect, useState } from 'react'
import { RoundedBox } from '@react-three/drei';
import useStore from '../hooks/Store'

export const ShotBtn = ({ active = true, onClick = {}, ...props }) => {
    const position = [0.3, 1.56, 1.3];
    const [hovered, hover] = useState(false)
    const { countdown } = useStore();
    
    useEffect(() => {
        document.body.style.cursor = hovered ? 'pointer' : 'auto'
    }, [hovered])

    position[1] = active ? position[1] : position[1] - 0.02;

    return (
        <RoundedBox steps={1} smoothness={1} args={[.12, .1, .11]} radius={0.01}
            onClick={countdown > 0 ? onClick : {}}
            onPointerOver={(event) => hover(true)}
            onPointerOut={(event) => hover(false)}
            position={position}

        >
            <meshPhongMaterial
                emissiveIntensity={countdown > 0 ? .5 : 0} emissive={0xff0000}
                color={active && hovered ? 0xa0afff : 0x88aaff}
                specular={0xffffff} shininess={20}
            />
        </RoundedBox >

    )
}
export default ShotBtn;